module.exports = __webpack_public_path__ + "img/agreement.b6e2468e.svg";